export const RESET_STORAGE = 'RESET_STORAGE';
export const RESET_STORAGE_WITHOUT_USER_SESSION =
  'RESET_STORAGE_WITHOUT_USER_SESSION';
